import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-2627a0a1-0374-418a-a953-3cf834dcf631-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "ec-c85b26f0-f03c-46d0-b5a5-78046728abfe-__Layer_2_1_",
      style: {},
      transform: "matrix(-1, 0, 0, 1, 72, 0)"
    }, [
      _createElementVNode("g", { id: "ec-814a5cb6-026f-407c-9f93-643971f3a61c-__Layer_1-2" }, [
        _createElementVNode("path", {
          id: "ec-c0b3e1eb-9140-43a3-8478-8aecd56d6e5b-__format_italic",
          d: "m54 60h-9.6l-10.7-48h8.3c1.7 0 3-1.3 3-3s-1.3-3-3-3h-24c-1.7 0-3 1.3-3 3s1.3 3 3 3h9.6l10.7 48h-8.3c-1.7 0-3 1.3-3 3s1.3 3 3 3h24c1.7 0 3-1.3 3-3s-1.3-3-3-3z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }